import { useCallback, useEffect, useState } from 'react';
import { getMySpotifyVerificationRequests } from '../../api/auth.api';

export function useSpotifyVerifications(uid) {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading]   = useState(true);

  const refresh = useCallback(async () => {
    if (!uid) {
      setRequests([]);
      setLoading(false);
      return;
    }
    try {
      const data = await getMySpotifyVerificationRequests();
      setRequests(data);
    } catch (error) {
      console.error('useSpotifyVerifications error:', error);
    } finally {
      setLoading(false);
    }
  }, [uid]);

  useEffect(() => {
    setLoading(true);
    refresh();
    const id = setInterval(refresh, 15000);
    return () => clearInterval(id);
  }, [refresh]);

  return { requests, loading, refresh };
}
